import { IApprovalProduct } from "src/Components/Main/Approval/Approval";
import { ITestApproval } from "src/Interfaces/TestInterface";
import { API } from "src/Services/Api/Api";


export class ApprovalApi {
    private api: API;

    constructor(Api: API) {
        this.api = Api;
    }
    public getTestsForApproval(): Promise<ITestApproval[]> {
        return this.api.get('/approval/tests');
    }

    public submitForApproval(wellTestId: string): Promise<any> {
        return this.api.post(`/approval/tests/${wellTestId}/submit`, { id: wellTestId });
    }

    public approveTest(wellTestId: string): Promise<any> {
        return this.api.post(`/approval/tests/${wellTestId}/approve`, {});
    }

    public rejectTest(wellTestId: string): Promise<any> {
        return this.api.post(`/approval/tests/${wellTestId}/reject`, {});
    }

    public getProductsForApproval(): Promise<IApprovalProduct[]> {
        return this.api.get('/approval/products/');
    }

    public approveProduct(productId: string) {
        return this.api.post(`/approval/products/${productId}/approve`, {});
    }

    public rejectProduct(productId: string) {
        return this.api.post(`/approval/products/${productId}/reject`, {});
    }
}



// WEBPACK FOOTER //
// ./src/Stores/Tests/ApprovalApi.ts